export class ApiError extends Error {
  public status: number
  public code?: string
  public details?: Array<{ field: string; message: string }>
  public response?: Response

  constructor(status: number, errorData: any, response?: Response) {
    const message = errorData?.error || errorData?.detail || errorData?.message || `HTTP ${status} Error`
    super(message)
    
    this.name = 'ApiError'
    this.status = status
    this.code = errorData?.error?.code || errorData?.code
    this.details = errorData?.error?.details || errorData?.details
    this.response = response
  }

  // Check if error is authentication-related
  isAuthError(): boolean {
    return this.status === 401
  }

  // Check if error is permission-related
  isPermissionError(): boolean {
    return this.status === 403
  }

  // Check if error is validation-related
  isValidationError(): boolean {
    return this.status === 400 && Boolean(this.details)
  }

  // Check if error is rate limiting
  isRateLimitError(): boolean {
    return this.status === 429
  }

  // Check if error is network-related
  isNetworkError(): boolean {
    return this.status === 0
  }

  // Check if error is server-side
  isServerError(): boolean {
    return this.status >= 500
  }

  // Get user-friendly error message
  getUserMessage(): string {
    if (this.isAuthError()) {
      return 'Please sign in to continue'
    }
    if (this.isPermissionError()) {
      return this.message
    }
    if (this.isValidationError()) {
      return this.details?.[0]?.message || 'Please check your input and try again'
    }
    if (this.isRateLimitError()) {
      return 'Too many requests. Please wait and try again'
    }
    if (this.status === 0) {
      return 'Unable to connect to server. Please check your internet connection'
    }
    if (this.isServerError()) {
      return 'Server error. Please try again later'
    }
    
    return this.message || 'An unexpected error occurred'
  }
}
